export const environment = {
    production: false,
    companyName: 'Triupd X-Ray',
    companyCode: 3,
    whatsappNumber: '1818545586',
    // apiUrl: 'http://localhost:1001/p',
    // ImageApi: 'http://localhost:1001/uploads/',
    // webUrl: 'http://localhost:3000',
    webUrl: 'https://www.triupdx-ray.com',
    apiUrl: 'https://api.mediray.supersoftbd.com/p',
    ImageApi: 'https://api.mediray.supersoftbd.com/uploads/',
    emptyImg: 'https://www.mykite.in/kb/NoImageFound.jpg.png',
    keywords: ['medical equipment', 'healthcare products', 'x-ray', 'triupdx-ray', 'printer', 'medical printer', 'triupd', 'medical imaging', 'diagnostic equipment', 'radiology', 'healthcare technology'],
    emailConfig: {
        host: 'smtp.gmail.com',
        port: 587,
        secure: false,
        user: 'infoibsc10@gmail.com',
        pass: 'qymuvixaplsvlrxv',
        from: 'infoibsc10@gmail.com',
    }
};
